import "./SearchPageFilters.scss";
import { DropdownHierarchy, Button } from "/App.Components";
import { DropdownItemProps } from "/Models/Generated/DropdownItemProps";
import { DropdownHierarchyProps } from "/Models/Generated/DropdownHierarchyProps";

interface Props {
  filtersHeading?: string | undefined;
  setPageNumber: (page: number) => void;
  setLoading: (loading: boolean) => void;
  setYear: (newState: DropdownItemProps | undefined) => void;
  year: DropdownItemProps | undefined;
  setCategory: (newState: DropdownItemProps | undefined) => void;
  category: DropdownItemProps | undefined;
  categoryDropdown: DropdownHierarchyProps | undefined;
  yearDropdown: DropdownHierarchyProps | undefined;
  filterSelectedAriaLiveSuffix: string | undefined;
  clearAllFiltersButtonText: string | undefined;
}

const SearchPageFilters = ({
  filtersHeading,
  setPageNumber,
  setYear,
  year,
  setCategory,
  category,
  setLoading,
  categoryDropdown,
  yearDropdown,
  filterSelectedAriaLiveSuffix,
  clearAllFiltersButtonText,
}: Props) => {
  if (!categoryDropdown && !yearDropdown) {
    return null;
  }
  return (
    <div className="search-page-filters-norad">
      {filtersHeading && (
        <h2 className="search-page-filters-norad__heading">{filtersHeading}</h2>
      )}
      <div className="search-page-filters-norad__button-container">
        <Button
          disabled={!(year?.value || category?.value)}
          label={clearAllFiltersButtonText ?? ""}
          style="secondary"
          size="s"
          onClick={() => {
            if (year?.value || category?.value) {
              setPageNumber(1);
              setYear(undefined);
              setCategory(undefined);
              setLoading(true);
            }
          }}
        />
      </div>
      <div className="search-page-filters-norad__dropdowns">
        {yearDropdown && (
          <DropdownHierarchy
            {...yearDropdown}
            selected={year}
            setSelected={(year?: DropdownItemProps) => {
              setPageNumber(1);
              setYear(year);
              setLoading(true);
            }}
            filterSelectedAriaLiveSuffix={filterSelectedAriaLiveSuffix}
          />
        )}
        {categoryDropdown && (
          <DropdownHierarchy
            {...categoryDropdown}
            selected={category}
            setSelected={(category?: DropdownItemProps) => {
              setPageNumber(1);
              setCategory(category);
              setLoading(true);
            }}
            filterSelectedAriaLiveSuffix={filterSelectedAriaLiveSuffix}
          />
        )}
      </div>
    </div>
  );
};

export default SearchPageFilters;
